import React from "react";
import { Heading, useDisclosure } from "@chakra-ui/react";
import { Abnormalities, Form, Comment } from "./components";

const PhysicalExam: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [fieldName, setFieldName] = React.useState("");

  return (
    <>
      <Heading mb={4} as="h3" color="black" fontSize="lg" lineHeight="7">
        Physical Exam
      </Heading>
      <Form
        onOpen={onOpen}
        onFieldNameChange={(name: string) => setFieldName(name)}
      />
      <Abnormalities />
      {isOpen && (
        <Comment onClose={onClose} isOpen={isOpen} fieldName={fieldName} />
      )}
    </>
  );
};

export default PhysicalExam;
